export class ViewMode {
    public static readonly view: string = 'view';
    public static readonly edit: string = 'edit';
}
